import id from './id.js'
import initialState from './initial-state.js'
import selectorDefinitions from './selectors/index.js'

const abTestingReduxDefinition = {
  id,
  type: 'redux-module',
  initialState,
  eventReducers: {
    abTesting: (state, payload) => ({
      ...state,
      ...payload,
      loading: false,
    }),
  },
  selectorDefinitions,
}

export default abTestingReduxDefinition
